module.exports = __webpack_public_path__ + "img/error.7f82194b.svg";